<template>
  <div>
    <card shadow no-body>
        <div class="px-4">
            <avatar></avatar>
            <h5 class="mt-3 text-center" v-if="name">Olá, {{name}}!</h5>
            <div class="list-group mt-3 mb-4">
              <router-link to="/perfil" class="list-group-item list-group-item-action">
                <i class="ni ni-circle-08 mr-1"></i>
                Perfil
              </router-link>
              <router-link to="/perfil/enderecos" class="list-group-item list-group-item-action">
                <i class="fa fa-home mr-1"></i>
                Endereços
              </router-link>
              <router-link to="/perfil/pedidos" class="list-group-item list-group-item-action">
                <i class="ni ni-app mr-1"></i>
                Pedidos
              </router-link>
            </div>
        </div>
    </card>
    <router-link to="/contato" class="my-4 d-block text-center">Precisa de ajuda?</router-link>
  </div>
</template>

<script>
import Avatar from './Avatar.vue'

export default {
  name: 'profile-navigation',
  components: {
    Avatar: Avatar
  },
  props: {
    name: {
      type: String,
      default: ""
    },
  }
}
</script>

<style lang="scss">
    .profile-image {
        position: relative;
        margin: 0 auto;
        float: none;
        margin-top: -90px;
        img {
            box-shadow: 0 15px 35px rgba(50,50,93,.1),0 5px 15px rgba(0,0,0,.07)!important;
            width: 180px;
            height: 180px;
            background: #f4f5f7;
            margin: 0 auto;
            float: none;
            display: block;
            cursor: pointer;
            object-fit: cover;
        }
    }

    .list-group {
      .router-link-exact-active {
        background: #2dce89;
        border-color: #2dce89;
        color: #fff;
      }
      a[href="/perfil/enderecos"] {
        &.router-link-active {
          background: #2dce89;
          border-color: #2dce89;
          color: #fff;
        }
      }
      a[href="/perfil/pedidos"] {
        &.router-link-active {
          background: #2dce89;
          border-color: #2dce89;
          color: #fff;
        }
      }
    }
      
</style>
